"use client";

import React from "react";
import { GetStartedButton } from "@/components/Home/common/GetStarted";
import styles from "./index.module.css";

const StartBuildingButton = () => {
  const startButtonText = "Start building";

  return (
    <GetStartedButton className={styles.startButton}>
      {startButtonText}
    </GetStartedButton>
  );
};

export default StartBuildingButton;
